<script setup lang="ts">
import {Head, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import TextField from "@/Pages/auth/components/TextField.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";

interface Props {
    status?: string
    token: string,
    email: string,
}

defineOptions({layout: Layout})
const props = defineProps<Props>()
const form = useForm({
    email: props.email,
    token: props.token,
    password: '',
    password_confirmation: '',
})

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => {
            form.reset('password', 'password_confirmation')
        },
    })
}
</script>

<template>
    <Head title="Reset password" />
    <form-card
        :status="status"
        :loading="form.processing"
        :error-messages="form.errors.password || form.errors.password_confirmation"
        @submit="submit"
    >
        <template #title>
            Change password for <br> {{ form.email }}
        </template>
        <text-field
            v-model="form.password"
            label="Password"
            type="password"
        />
        <text-field
            v-model="form.password_confirmation"
            label="Confirm password"
            type="password"
            details="Make sure it's at least 9 characters including a number and a uppercase letter."
        />
        <template #submit>
            Change password
        </template>
    </form-card>
</template>

<style scoped>

</style>
